<script setup lang="ts">
import { alphabetToPref, prefOrder } from "~/utils/sekou/area";
const areas = await useSekouArea();

// Map<都道府県, 市区町村[]>のデーターを作成
const prefCities = computed(() => {
  const tmp = new Map<
    string,
    { pref: string; city: string; count: number }[]
  >();
  if (areas.value) {
    for (const area of areas.value) {
      if (!tmp.has(area.pref)) {
        tmp.set(area.pref, []);
      }
      const target = tmp.get(area.pref);
      if (target) {
        target.push(area);
      }
    }
  }

  const result = new Map();
  prefOrder.forEach((alpref) => {
    const pref = alphabetToPref(alpref);
    if (pref) {
      result.set(pref, tmp.get(pref) || []);
    }
  });

  return result;
});

// 現在のrouteの都道府県
const basePref = alphabetToPref(
  (useRoute().path as string).slice(7).split("_")[0],
);
</script>

<template>
  <div class="flex flex-wrap flex-col">
    <MenuAccordion
      v-for="areaBase in prefCities"
      :title="areaBase[0]"
      :open="basePref == areaBase[0]"
    >
      <ul class="flex flex-col max-h-[400px] overflow-y-scroll">
        <SekouAreaLink :prefecture="areaBase[0]" :shikuAreas="areaBase[1]" />
      </ul>
    </MenuAccordion>
  </div>
</template>
